import validationSchemaFieldFragment from 'Store/validation-schema/validationSchemaField.fragment';
import { addressFragment } from 'Utils/graphql-query-helper/address/addressQuery';

export const getCivilitiesQuery = () => `
query {
  civilities {
    adult {
      label
      value: code
    }
    child {
      label
      value: code
    }
  }
}`;

export const getI18nQuery = () => `
query {
  config {
    booking {
      common {
        layer {
          unknownErrorDescription
        }
      }
      form {
        dateFormat
        dayPlaceholder
        monthPlaceholder
        yearPlaceholder
      }
      participants {
        labels {
          birthdate
          email
          firstName
          lastName
          passportInfo
          phone
          unicodeFirstName
          unicodeLastName
        }
      }
    }
    common {
      cancel
      dateFormatPlaceholder
      dateFormatTechnicalID
      form {
        errors {
          fieldTooLong
          fieldTooShort
          invalidDateField
          invalidEmailField
          issuingCountryLength
          maximumAgeRequired
          minimumAgeRequired
          noSpecialCharsField
          passportMaxMinLength
          phoneNumberError
          requiredField
        }
      }
      participants {
        address {
          additionalInformation1
          additionalInformation2
          addOn
          city
          countryCode
          stateOrDistrict
          streetNumber
          streetName
          town
          zipCode
        }
      }
      save
    }
  }
}
`;

export const getLegalInformations = () => `query {
  legalInformations {
    foryouClubOptins {
      description
      id
      ref
      title
    }
    consentOptins {
      description
      id
      ref
      title
    }
    bookingProcess {
      id
      label
      description
      url
      required
      preChecked
    }
    newsletter {
      id
      label
      description
    }
  }
}`;

export const getProfileQuery = () => `query {
  profile {
    address {
      ...Address
    }
    civility
    customerId
    dateOfBirth
    email
    firstName
    secondName
    thirdName
    fourthName
    gmNumber
    homePhoneNumber
    identityNumber
    lastName
    mobilePhoneNumber
    optins {
      channel
      optin
    }
    passport {
      authority
      birthCountry
      birthCity
      secondName
      thirdName
      fourthName
      birthdate
      birthplace
      countryCode
      documentNumber
      expirationDate
      firstName
      issuingCountry
      issuingDate
      nationality
      residenceCity
      serialNumber
      unicodeFirstName
      unicodeLastName
    }
    personalDataUsageAllowed
    unicodeCivility
    unicodeFirstName
    unicodeSecondName
    unicodeThirdName
    unicodeFourthName
    unicodeLastName
  }
  }
  ${addressFragment}
  `;

export const getTravelCompanionsQuery = () => `query {
  travelCompanions {
    customerId
    civility
    unicodeCivility
    firstName
    lastName
    unicodeFirstName
    unicodeLastName
    dateOfBirth
    email
    mobilePhoneNumber
    passport {
      secondName
      thirdName
      fourthName
      unicodeSecondName
      unicodeThirdName
      unicodeFourthName
      documentNumber
      issuingCountry
      authority
      issuingDate
      expirationDate
    }
  }
}`;

export const getAddressFieldsQuery = () => `query {
  validationSchema(resource : "profile", fields: ["address"]) {
    ...ValidationSchemaField
  }
}
${validationSchemaFieldFragment}
`;
